import React from 'react';
import { motion } from 'framer-motion';
import { Play } from 'lucide-react';
export function VideoSection() {
  return <section className="py-20 bg-white" data-id="element-141">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-142">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-143">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0A2540] mb-4" data-id="element-144">
            What Our Clients Are Saying
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-145">
            Hear directly from a boat dealer and see how a custom-built website
            can transform your online presence and drive real results.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="relative aspect-video bg-slate-800 rounded-xl overflow-hidden shadow-2xl border border-slate-300 group cursor-pointer" data-id="element-146">
          <img src="https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?auto=format&fit=crop&q=80&w=1000" alt="Boat dealership showroom" className="w-full h-full object-cover opacity-60 group-hover:opacity-70 transition-opacity duration-300" data-id="element-147" />
          <div className="absolute inset-0 flex items-center justify-center" data-id="element-148">
            <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/30 group-hover:scale-110 transition-transform duration-300" data-id="element-149">
              <Play className="w-8 h-8 text-white fill-white ml-1" data-id="element-150" />
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}